import ReportComponent from "~/components/pages/supervisor/reports";

export default function ReportsPage() {
  return (
    <div>
      <ReportComponent />
    </div>
  );
}
